// frontend/src/components/leaderboard/LeaderboardRow.tsx

import { LeaderboardEntry } from '../../types/leaderboard.types';

function initials(name: string): string {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join('');
}

function rankClass(rank: number): string {
  if (rank === 1) return 'gold';
  if (rank === 2) return 'silver';
  if (rank === 3) return 'bronze';
  return 'normal';
}

function renderRankIcon(rank: number): string | number {
  if (rank === 1) return '🏆';
  if (rank === 2) return '🥈';
  if (rank === 3) return '🥉';
  return rank;
}

function calculateLevel(xp: number): number {
  return Math.floor(xp / 250) + 1;
}

function getAvatarStyle(name: string): string {
  const colors = [
    'linear-gradient(135deg, #4f46e5, #818cf8)', // indigo-blue
    'linear-gradient(135deg, #a855f7, #c084fc)', // purple-violet
    'linear-gradient(135deg, #06b6d4, #3b82f6)', // cyan-blue
    'linear-gradient(135deg, #ec4899, #f472b6)', // pink-magenta
    'linear-gradient(135deg, #10b981, #34d399)', // emerald-green
  ];
  let sum = 0;
  for (let i = 0; i < name.length; i++) {
    sum += name.charCodeAt(i);
  }
  return colors[sum % colors.length];
}

interface LeaderboardRowProps {
  entry: LeaderboardEntry;
}

export function LeaderboardRow({ entry }: LeaderboardRowProps) {
  const level = calculateLevel(entry.xp);

  return (
    <div className={`leaderboard-item ${entry.isCurrentUser ? 'current-user' : ''}`}>
      <div className={`leaderboard-rank ${rankClass(entry.rank)}`}>
        {renderRankIcon(entry.rank)}
      </div>
      
      <div 
        className="leaderboard-avatar" 
        style={{ background: getAvatarStyle(entry.displayName) }}
      >
        {initials(entry.displayName)}
      </div>

      <div className="leaderboard-info">
        <h4>
          {entry.displayName}
          {entry.isCurrentUser && <span className="current-tag">(Sen)</span>}
        </h4>
        <p>
          {entry.schoolName && <span style={{ fontWeight: 500 }}>{entry.schoolName} · </span>}
          Seviye {level} • {entry.completedCourses} ders tamamlandı
        </p>
      </div>

      <div className="league-xp-pill">
        <span className="xp-lightning-icon">⚡</span>
        <span className="xp-value">{entry.xp.toLocaleString('tr-TR')}</span>
        <span className="xp-label">XP</span>
      </div>
    </div>
  );
}
